var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _circle, _path57;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 116,
    viewBox: "0 0 146 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.62143 84.5363H144.137",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.342 84.9484V113.871",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 84.5363V114.492",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82399 95.0728H143.514",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4097 104.369H58.6029",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9753 104.782H143.722",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9832 65.1158V113.872",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5614 64.9099V113.666",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.781 39.2924H113.972",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6961 31.649H104.054",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2637 13.8811H93.1031",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4397 19.2529H92.8989",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6904 14.7084V18.8403",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4397 13.2608V18.219",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1901 19.666V25.0374",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88.773 19.666V26.0703",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8928 9.31973H77.8699",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6583 4.94751H76.2313",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1937 1.23273H74.0514",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6726 103.714V113.85",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0204 103.556V114.326",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7357 103.315C68.8855 103.032 69.0277 102.777 69.1656 102.501C69.3124 102.208 69.5936 102.034 69.7814 101.787C70.3782 101.002 71.5459 100.974 72.3928 100.677C72.67 100.58 73.022 100.542 73.3107 100.491C73.5418 100.451 73.7559 100.439 73.9904 100.439C74.5113 100.439 74.8319 100.571 75.2714 100.831C76.0661 101.301 77.5215 101.701 77.7812 102.74",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88474 108.306V111.324",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2107 108.306V111.324",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5367 108.306V111.324",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8627 108.306V111.324",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1888 108.306V111.324",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5238 108.306V111.324",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8498 108.306V111.324",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9463 108.306V111.324",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M102.272 108.306V111.324",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M109.598 108.306V111.324",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M116.924 108.306V111.324",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M124.25 108.306V111.324",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M131.585 108.306V111.324",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M138.911 108.306V111.324",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88474 88.7081V91.7261",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2107 88.7082V91.7262",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5367 88.7082V91.7262",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8627 88.7082V91.7262",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1888 88.7082V91.7262",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5238 88.7082V91.7262",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8498 88.7082V91.7262",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9463 88.7081V91.7261",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M102.272 88.7082V91.7262",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M109.598 88.7082V91.7262",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M116.924 88.7082V91.7262",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M124.25 88.7082V91.7262",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M131.585 88.7082V91.7262",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M138.911 88.7082V91.7262",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8449 73.2299H57.4536",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5659 78.9257H57.7948",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3133 73.2299H92.9784",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4799 78.3619H92.863",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3698 73.0621C59.4998 73.0477 59.6857 72.837 59.7896 72.752C60.0276 72.5572 60.3828 72.4133 60.6667 72.3009C61.415 72.0047 62.1982 71.8379 62.9503 71.571C63.611 71.3366 64.3833 71.2805 65.0115 70.9978C65.6563 70.7076 66.4019 70.5512 67.0978 70.412C67.7308 70.2854 68.3565 70.1214 68.9804 69.9609C69.3834 69.8573 69.7976 69.7567 70.2083 69.6915C70.5632 69.6352 70.9552 69.5176 71.311 69.5098C71.9924 69.495 72.6723 69.3655 73.3534 69.3407C74.0314 69.316 74.702 69.2843 75.3833 69.2843C75.6746 69.2843 75.9659 69.2843 76.2573 69.2843C76.518 69.2843 76.7354 69.4122 76.9934 69.4535C77.6621 69.5604 78.2863 69.9292 78.9387 70.1019C79.6701 70.2955 80.3678 70.5715 81.1283 70.6407C81.7059 70.6932 82.2795 70.9592 82.8512 71.0354C83.4721 71.1182 84.1111 71.5016 84.7057 71.6838C85.2629 71.8546 85.8151 72.0243 86.3784 72.1725C86.8699 72.3018 87.3606 72.5029 87.8445 72.6674C88.182 72.7822 88.6864 72.8716 88.9722 73.0621",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3698 78.076C59.4998 78.0615 59.6857 77.8508 59.7896 77.7658C60.0276 77.571 60.3828 77.4271 60.6667 77.3147C61.415 77.0185 62.1982 76.8517 62.9503 76.5849C63.611 76.3504 64.3833 76.2943 65.0115 76.0116C65.6563 75.7214 66.4019 75.565 67.0978 75.4258C67.7308 75.2992 68.3565 75.1352 68.9804 74.9748C69.3834 74.8711 69.7976 74.7706 70.2083 74.7054C70.5632 74.649 70.9552 74.5314 71.311 74.5237C71.9924 74.5089 72.6723 74.3793 73.3534 74.3545C74.0314 74.3299 74.702 74.2981 75.3833 74.2981C75.6746 74.2981 75.9659 74.2981 76.2573 74.2981C76.518 74.2981 76.7354 74.426 76.9934 74.4673C77.6621 74.5743 78.2863 74.943 78.9387 75.1157C79.6701 75.3093 80.3678 75.5854 81.1283 75.6545C81.7059 75.707 82.2795 75.973 82.8512 76.0492C83.4721 76.132 84.1111 76.5154 84.7057 76.6976C85.2629 76.8684 85.8151 77.0381 86.3784 77.1863C86.8699 77.3156 87.3606 77.5167 87.8445 77.6813C88.182 77.796 88.6864 77.8854 88.9722 78.076",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73.3287,
    cy: 61.0896,
    r: 2.46282,
    stroke: "#DFDFDF",
    strokeWidth: 2.27938
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M134.568 83.9055C134.568 50.0821 107.149 23.8637 73.3257 23.8637C39.5024 23.8637 13.284 50.0821 13.284 83.9055",
    stroke: "#DFDFDF",
    strokeWidth: 2.27938,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonument);
export default __webpack_public_path__ + "static/media/monument.74f30f18b1766f04045cf5efabb1a478.svg";
export { ForwardRef as ReactComponent };